import { useState, useRef, useEffect } from "react";
import Header from "../../components/Navbar";
import "../Map/map.css";
import { FaMapMarkedAlt } from "react-icons/fa";
import Nearloaction from "../../myimgs/nearlocn.png";
import Swal from "sweetalert2";
import Residin from "../../myimgs/Union (2).png";
import Vectors from "../../myimgs/Vector (4).png";
import {
  LoadScriptNext,
  GoogleMap,
  Marker,
  Autocomplete,
  Circle,
} from "@react-google-maps/api";
import {
  propertyTypes,
  priceList,
  bedsList,
  bathsList,
  squareFootageList,
  storeysList,
  maintenanceFeeMonthlyList,
  propertyTaxYearlyList,
  yearBuiltList,
  farmList,
  parkingList,
  buildingStyleList,
  numberOfUnitsList,
  exteriorBuildingSizeList,
  zoningTypeList,
  buildingTypes,
} from "../../data/states";
import placeimg from "../../myimgs/Group 193.png";
import resetimg from "../../myimgs/circular (1).png";
const residentialTypes = [
  "Any",
  "Residential",
  "Condo/Strata",
  "Vacant Land",
  "Single Family",
  "Recreational",
  "Multi-family",
  "Agriculture",
  "Parking",
  "Other",
];

const commercialTypes = [
  "Any",
  "Business",
  "Multi-family",
  "Retail",
  "Industrial",
  "Office",
  "Vacant Land",
  "Agriculture",
  "Hospitality",
  "Institutional",
  "Other",
];

/* ---------------- MAP CONFIG ---------------- */
const mapContainerStyle = {
  height: "100vh",
  width: "100%",
};

/* -------- CANADA SETTINGS -------- */
const CANADA_CENTER = { lat: 56.1304, lng: -106.3468 };

const CANADA_SOFT_BOUNDS = {
  north: 88,
  south: 40,
  west: -155,
  east: -40,
};
const isMobileDevice = window.innerWidth <= 480;

const mapOptions = {
  minZoom: isMobileDevice ? 3 : 4,
  maxZoom: 20,

  // ✅ APPLY BOUNDS ONLY ON BIG SCREEN
  ...(isMobileDevice
    ? {} // ❌ NO bounds on small devices
    : {
        restriction: {
          latLngBounds: CANADA_SOFT_BOUNDS,
          strictBounds: false,
        },
      }),

  fullscreenControl: false,
  streetViewControl: false,
  mapTypeControl: false,
};

const handleViewDetails = (id, propeId, listedBy, email) => {
  const encodedListedBy = encodeURIComponent(listedBy || "");
  const encodedEmail = encodeURIComponent(email || "");
  // Open the route in a new tab with query params
  const url = `/propertyDetail?id=${id}&propeId=${propeId}&listedBy=${encodedListedBy}&email=${encodedEmail}`;
  window.open(url, "_blank");
};
/* ---------------- CLUSTER ICON ---------------- */
const generateClusterIcon = (count) => {
  if (!window.google) return undefined;

  // const size = 42 + Math.min(count / 5, 25);
  const isMobile = window.innerWidth <= 480;

  const size = isMobile
    ? 34 + Math.min(count / 6, 18) // smaller clusters
    : 42 + Math.min(count / 5, 25); // desktop same

  const color = count > 1000 ? "#c62828" : count > 100 ? "#ef6c00" : "#1565c0";

  return {
    url:
      "data:image/svg+xml;charset=UTF-8," +
      encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
          <circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - 3}"
            fill="${color}" stroke="white" stroke-width="3"/>
          <text x="50%" y="55%"
            text-anchor="middle"
            font-size="12"
            font-weight="bold"
            fill="white">${count}</text>
        </svg>
      `),
    scaledSize: new window.google.maps.Size(size, size),
    anchor: new window.google.maps.Point(size / 2, size / 2),
  };
};

const filterLabels = {
  propertyType: "Property Type",
  minPrice: "Min Price",
  maxPrice: "Max Price",
  beds: "Beds",
  baths: "Baths",
  farmType: "Farm Type",
  parkingType: "Parking",
  buildingType: "Building Type",
  Stories: "Stories",
  numberOfUnits: "Units",
  exteriorBuildingSize: "Exterior Size",
  landSize: "Land Size",
  zoningType: "Zoning",
  maintenanceFeeMin: "Min Maintenance",
  maintenanceFeeMax: "Max Maintenance",
  propertyTaxMin: "Min Tax",
  propertyTaxMax: "Max Tax",
  yearBuiltFrom: "Year Built From",
  yearBuiltTo: "Year Built To",
};

function Map() {
  const mapRef = useRef(null);
  const autocompleteRef = useRef(null);
  const debounceRef = useRef(null);
  const [totalPages, setTotalPages] = useState(0);
  const [isFirstPage, setIsFirstPage] = useState(true);
  const [isLastPage, setIsLastPage] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(30);
  const [showNearby, setShowNearby] = useState(false);
  const [searchCircleCenter, setSearchCircleCenter] = useState(null);
  const [showNoData, setShowNoData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isResidential, setIsResidential] = useState(true); // default Residential
    const propertyTypeOptions = isResidential
      ? residentialTypes
      : commercialTypes;

  // ===== MORE FILTER STATES =====
  const [propertyTypex, setPropertyTypex] = useState("");

  const [beds, setBeds] = useState("");
  const [baths, setBaths] = useState("");

  const [farmType, setFarmType] = useState("");
  const [parkingType, setParkingType] = useState("");
  const [buildingStyle, setBuildingStyle] = useState("");
  const [buildingType, setBuildingType] = useState("");

  const [Stories, setStories] = useState("");

  const [numberOfUnits, setNumberOfUnits] = useState("");
  const [exteriorBuildingSize, setExteriorBuildingSize] = useState("");

  const [ownershipTitle, setOwnershipTitle] = useState("");
  const [zoningType, setZoningType] = useState("");
  const [landSize, setLandSize] = useState("");

  const [minSquareFootage, setMinSquareFootage] = useState("");
  const [maxSquareFootage, setMaxSquareFootage] = useState("");

  const [maintenanceFeeMin, setMaintenanceFeeMin] = useState("");
  const [maintenanceFeeMax, setMaintenanceFeeMax] = useState("");

  const [propertyTaxMin, setPropertyTaxMin] = useState("");
  const [propertyTaxMax, setPropertyTaxMax] = useState("");

  const [yearBuiltFrom, setYearBuiltFrom] = useState("");
  const [yearBuiltTo, setYearBuiltTo] = useState("");

  const [listedSince, setListedSince] = useState("");

  const [showFilter, setShowFilter] = useState(false);

  /* ---------------- HELPERS ---------------- */
  const formatPrice = (price) =>
    price ? `$${price.toLocaleString("en-CA")}` : "N/A";

  /* ---------------- STATES ---------------- */
  const [search, setSearch] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  // const [mapCenter] = useState(CANADA_CENTER);
  const [mapCenter, setMapCenter] = useState(CANADA_CENTER);

  // const [mapZoom, setMapZoom] = useState(4);
  const isMobile = window.innerWidth <= 480;

  const [mapZoom, setMapZoom] = useState(isMobile ? 2.8 : 4);

  const [mapClusters, setMapClusters] = useState([]);
  const [loading, setLoading] = useState(false);

  /* -------- CLUSTER POPUP -------- */
  const [showPopup, setShowPopup] = useState(false);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [clusterProperties, setClusterProperties] = useState([]);
  const [clusterPage, setClusterPage] = useState(0);
  const [clusterLoading, setClusterLoading] = useState(false);
  const hasFiltersApplied =
    search || propertyType || minPrice || maxPrice || showNearby;

  const [isApplyingSearch, setIsApplyingSearch] = useState(false);
  const skipNextIdleRef = useRef(false);
  const applyOnceRef = useRef(false); // 🔥 new

  const selectedPredictionRef = useRef(null);
  const searchInputRef = useRef(null);

  /* ---------------- AUTOCOMPLETE ---------------- */
  const handleAutocompleteLoad = (ac) => {
    autocompleteRef.current = ac;
    ac.setOptions({ componentRestrictions: { country: "ca" } });
  };

  // const handlePlaceChanged = () => {
  //   const place = autocompleteRef.current?.getPlace();
  //   if (!place?.geometry || !mapRef.current) return;

  //   const lat = place.geometry.location.lat();
  //   const lng = place.geometry.location.lng();

  //   setSearch(place.formatted_address || "");

  //   setMapCenter({ lat, lng });
  //   setMapZoom(12);

  //   //Circle center set
  //   setSearchCircleCenter({ lat, lng });

  //   mapRef.current.panTo({ lat, lng });
  //   mapRef.current.setZoom(12);
  // };

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current?.getPlace();
    if (!place?.geometry || !mapRef.current) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    // ✅ what user actually selected (visible text)
    const visibleText = searchInputRef.current.value;

    selectedPredictionRef.current = {
      placeId: place.place_id,
      description: visibleText,
    };

    setSearch(visibleText);

    setMapCenter({ lat, lng });
    setMapZoom(12);

    setSearchCircleCenter({ lat, lng });

    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(12);
  };

  /* ---------------- MAP CLUSTER API ---------------- */
  const fetchMapProperties = async () => {
    if (!mapRef.current) return;

    const bounds = mapRef.current.getBounds();
    if (!bounds) return;

    const north = bounds.getNorthEast().lat();
    const east = bounds.getNorthEast().lng();
    const south = bounds.getSouthWest().lat();
    const west = bounds.getSouthWest().lng();
    const zoom = mapRef.current.getZoom();

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userId = Number(localStorage.getItem("userId") || 0);
    // const nearbyLat = localStorage.getItem("nearby_lat");
    // const nearbyLng = localStorage.getItem("nearby_lng");
    const body = {
      // page,
      size: pageSize,
      currentUser: userId,

      // STATIC FLAGS
      sell: false,
      forBidinng: true,
      isApproved: true,

       isResidential: isResidential,

      // BASIC FILTERS
      // search: filters?.searchOverride || search || null,
      search: search,
      propertyType: propertyType || propertyTypex || null,

      // PRICE
      propertyValueFrom: cleanNumber(minPrice),
      propertyValueTo: cleanNumber(maxPrice),

      // BEDS / BATHS
      bedRooms: beds || null,
      bathroms: baths || null,

      // SQUARE FOOTAGE
      propertySizeMin: cleanNumber(minSquareFootage),
      propertySizeMax: cleanNumber(maxSquareFootage),

      // MORE FILTERS
      buildingType: buildingType || null,
      farmType: farmType || null,
      parkingType: parkingType || null,
      buildingStyle: buildingStyle || null,

      numberOfUnit: numberOfUnits || null,
      exteriarBuldinngSizeMin: exteriorBuildingSize || null,
      ownershipTitle: ownershipTitle || null,
      zoningType: zoningType || null,
      stories: Stories || null,

      // LAND SIZE
      landSize: landSize || null,

      // LISTED DATE
      listedSince: formatDate(listedSince),

      // MAINTENANCE FEES
      mantainceFeeMonthlyMin: cleanNumber(maintenanceFeeMin),
      mantainceFeeMonthlyMax: cleanNumber(maintenanceFeeMax),

      // PROPERTY TAX
      propertyTaxYearlyMin: cleanNumber(propertyTaxMin),
      propertyTaxYearlyMax: cleanNumber(propertyTaxMax),

      // YEAR BUILT
      yearBuiltFrom: yearBuiltFrom || null,
      yearBuiltTo: yearBuiltTo || null,
    };

    const url =
      `${baseUrl}/property/map-v1` +
      `?north=${north}&south=${south}&east=${east}&west=${west}&zoom=${zoom}`;

    try {
      setLoading(true);
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const json = await res.json();
      setMapClusters(Array.isArray(json?.data) ? json.data : []);
    } catch (err) {
      console.error("Map API error:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- PROJECTION API ---------------- */
  const fetchClusterProperties = async (cluster, page = 0) => {
    try {
      setClusterLoading(true);
      const baseUrl = process.env.REACT_APP_API_BASE_URL;

      const url = `${baseUrl}/property/projection-v1?gridLat=${cluster.gridLat}&gridLng=${cluster.gridLng}&zoom=${mapZoom}&page=${page}`;

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...getCommonFilterPayload(), // 🔥 SAME FILTERS
          page,
          size: pageSize,
        }),
      });

      const json = await res.json();
      setClusterProperties(json?.content || []);
      setClusterPage(json?.number ?? page);
      setTotalPages(json?.totalPages ?? 0);
      setIsFirstPage(json?.first ?? true);
      setIsLastPage(json?.last ?? false);
      setTotalElements(json?.totalElements ?? 0);
      setPageSize(json?.size ?? 30);
    } catch (err) {
      console.error("Projection API error:", err);
    } finally {
      setClusterLoading(false);
    }
  };

  /* ---------------- DEBOUNCE ---------------- */
  const debouncedFetch = () => {
    if (applyOnceRef.current) {
      applyOnceRef.current = false;
      fetchMapProperties(); // ✅ SINGLE HIT
      return;
    }

    // normal case (drag / zoom)
    if (skipNextIdleRef.current) {
      skipNextIdleRef.current = false;
      return;
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(fetchMapProperties, 700);
  };

  useEffect(() => {
    return () => debounceRef.current && clearTimeout(debounceRef.current);
  }, []);

  // pagenation...
  const getPaginationItems = () => {
    const set = new Set();

    const current = clusterPage;
    const last = totalPages - 1;

    set.add(0);

    if (current > 2) set.add("dots-start");

    for (
      let i = Math.max(1, current - 1);
      i <= Math.min(last - 1, current + 1);
      i++
    ) {
      set.add(i);
    }

    if (current < last - 2) set.add("dots-end");

    if (last > 0) set.add(last);

    return Array.from(set);
  };

  // pagenation...
  const getHeaderRangeText = () => {
    if (totalElements === 0) return "0 Properties";

    const start = clusterPage * pageSize + 1;
    const end = Math.min((clusterPage + 1) * pageSize, totalElements);

    return `${start}–${end} of ${totalElements} Properties`;
  };
  // getCurrentLocation.apply...
  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject({ message: "Geolocation not supported" });
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          // ❌ NEVER pass raw error object
          reject({
            code: error.code,
            message:
              error.code === 1
                ? "Location permission denied"
                : error.code === 2
                  ? "Location unavailable"
                  : "Location request timed out",
          });
        },
      );
    });
  };

  // 🔥 MORE FILTER APPLY (same as top apply)
  const handleMoreFilterApply = () => {
    skipNextIdleRef.current = true;
    applyOnceRef.current = true;

    // 🔥 GUARANTEED SYNC
    setPropertyType(() => propertyTypex || "");

    setShowFilter(false);

    // 🔥 MAP MOVE / IDLE trigger
    if (mapRef.current) {
      mapRef.current.panTo(mapRef.current.getCenter());
    }
  };

  const resetAllFilters = () => {
    setSearch("");
    setPropertyType("");
    setPropertyTypex("");

    setMinPrice("");
    setMaxPrice("");

    setBeds("");
    setBaths("");
    setFarmType("");
    setParkingType("");
    setBuildingStyle("");
    setBuildingType("");
    setStories("");
    setNumberOfUnits("");
    setExteriorBuildingSize("");
    setLandSize("");
    setZoningType("");

    setMinSquareFootage("");
    setMaxSquareFootage("");

    setMaintenanceFeeMin("");
    setMaintenanceFeeMax("");
    setPropertyTaxMin("");
    setPropertyTaxMax("");

    setYearBuiltFrom("");
    setYearBuiltTo("");

    setSearchCircleCenter(null);
    setShowNearby(false);

    if (mapRef.current) {
      mapRef.current.panTo(CANADA_CENTER);
      mapRef.current.setZoom(4);
    }

    applyOnceRef.current = true;
  };

  // getCurrentLocation.apply...

  // pagereloadnaermestore...

  // first suggestion aurocomplete ...
  const getFirstSuggestion = (input) => {
    return new Promise((resolve) => {
      if (!input || !window.google?.maps?.places) {
        resolve(null);
        return;
      }

      const service = new window.google.maps.places.AutocompleteService();

      service.getPlacePredictions(
        {
          input,
          componentRestrictions: { country: "ca" },
        },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions?.length
          ) {
            resolve(predictions[0]); // FIRST suggestion
          } else {
            resolve(null);
          }
        },
      );
    });
  };

  // const handleApply = async () => {
  //   // block random idle
  //   skipNextIdleRef.current = true;
  //   applyOnceRef.current = true; // allow exactly ONE idle hit

  //   // CASE 1: EMPTY SEARCH
  //   if (!search || !search.trim()) {
  //     setSearchCircleCenter(null);
  //     setShowNearby(false);

  //     localStorage.removeItem("nearby_lat");
  //     localStorage.removeItem("nearby_lng");

  //     if (mapRef.current) {
  //       mapRef.current.panTo(CANADA_CENTER);
  //       mapRef.current.setZoom(4);
  //     }
  //     return;
  //   }

  //   // CASE 2: SEARCH EXISTS
  //   const prediction = await getFirstSuggestion(search);
  //   if (!prediction) return;

  //   const geocoder = new window.google.maps.Geocoder();

  //   geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
  //     if (status === "OK" && results?.[0]) {
  //       const loc = results[0].geometry.location;

  //       const lat = loc.lat();
  //       const lng = loc.lng();

  //       // setSearch(results[0].formatted_address);
  //       setSearch(prediction.description); // ✅ keep user-visible text
  //       setSearchCircleCenter({ lat, lng });
  //       setMapCenter({ lat, lng });
  //       // setMapZoom(12);

  //       // if (mapRef.current) {
  //       //   mapRef.current.panTo({ lat, lng });
  //       //   mapRef.current.setZoom(12);
  //       // }
  //       const targetZoom = window.innerWidth <= 480 ? 7 : 12;

  //       setMapZoom(targetZoom);

  //       if (mapRef.current) {
  //         mapRef.current.panTo({ lat, lng });
  //         mapRef.current.setZoom(targetZoom);
  //       }
  //     }
  //   });
  // };

  const handleApply = async () => {
    skipNextIdleRef.current = true;
    applyOnceRef.current = true;

    // CASE 1: EMPTY SEARCH
    if (!search || !search.trim()) {
      setSearchCircleCenter(null);
      setShowNearby(false);

      localStorage.removeItem("nearby_lat");
      localStorage.removeItem("nearby_lng");

      if (mapRef.current) {
        mapRef.current.panTo(CANADA_CENTER);
        mapRef.current.setZoom(4);
      }
      return;
    }

    let prediction = null;

    // ✅ CASE A: user selected from dropdown
    if (selectedPredictionRef.current) {
      prediction = selectedPredictionRef.current;
    }
    // ✅ CASE B: user typed & pressed Apply / Enter
    else {
      prediction = await getFirstSuggestion(search);
    }

    if (!prediction) return;

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
      if (status === "OK" && results?.[0]) {
        const loc = results[0].geometry.location;
        const lat = loc.lat();
        const lng = loc.lng();

        setSearch(prediction.description); // ✅ always user-visible text
        setSearchCircleCenter({ lat, lng });
        setMapCenter({ lat, lng });

        const targetZoom = window.innerWidth <= 480 ? 7 : 12;
        setMapZoom(targetZoom);

        if (mapRef.current) {
          mapRef.current.panTo({ lat, lng });
          mapRef.current.setZoom(targetZoom);
        }
      }
    });
  };

  // first suggestion aurocomplete ...

  // remove , with amount ...
  const parsePrice = (value) => {
    if (!value) return null;
    return Number(value.toString().replace(/,/g, ""));
  };
  // remove , with amount ...
  // date formatter (API safe)
  const formatDate = (date) => {
    if (!date) return null;
    return date; // agar future me format chahiye to yahin change
  };

  // remove commas & empty values
  const cleanNumber = (value) => {
    if (!value) return null;
    return Number(value.toString().replace(/,/g, ""));
  };

  // Common Enter handler
  const handleEnterApply = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // at least one filter applied ho
      if (search || propertyType || minPrice || maxPrice) {
        handleApply();
      }
    }
  };
  // Common Enter handler

  // Common filter payload
  const getCommonFilterPayload = () => {
    return {
      search: search || null,
      propertyType: propertyType || null,
      propertyValueFrom: parsePrice(minPrice),
      propertyValueTo: parsePrice(maxPrice),
      isApproved: true,
      forBidinng: true,

      // More FILTERS
      bedRooms: beds || null,
      bathroms: baths || null,

      farmType: farmType || null,
      parkingType: parkingType || null,
      buildingType: buildingType || null,
      buildingStyle: buildingStyle || null,

      isResidential: isResidential,

      stories: Stories || null,
      numberOfUnit: numberOfUnits || null,
      exteriarBuldinngSizeMin: exteriorBuildingSize || null,

      landSize: landSize || null,
      zoningType: zoningType || null,

      mantainceFeeMonthlyMin: cleanNumber(maintenanceFeeMin),
      mantainceFeeMonthlyMax: cleanNumber(maintenanceFeeMax),

      propertyTaxYearlyMin: cleanNumber(propertyTaxMin),
      propertyTaxYearlyMax: cleanNumber(propertyTaxMax),

      yearBuiltFrom: yearBuiltFrom || null,
      yearBuiltTo: yearBuiltTo || null,
    };
  };
  // Common filter payload
  // no property delay ..
  useEffect(() => {
    let timer;

    if (!loading && mapClusters.length === 0 && hasFiltersApplied) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 1000); // ⏱ 3 seconds
    } else {
      setShowNoData(false); // reset
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [loading, mapClusters, hasFiltersApplied]);
  // no property delay ..
  const removeAppliedFilter = (key) => {
    setAppliedFilters((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });

    // also clear actual filter state
    switch (key) {
      case "propertyType":
        setPropertyType("");
        setPropertyTypex("");
        break;
      case "minPrice":
        setMinPrice("");
        break;
      case "maxPrice":
        setMaxPrice("");
        break;
      case "beds":
        setBeds("");
        break;
      case "baths":
        setBaths("");
        break;
      default:
        break;
    }

    applyOnceRef.current = true;
    skipNextIdleRef.current = true;

    if (mapRef.current) {
      mapRef.current.panTo(mapRef.current.getCenter());
    }
  };
  const formatFilterValue = (key, value) => {
    if (!value) return "";

    if (key.includes("Price") || key.includes("Tax") || key.includes("Fee")) {
      return `$${Number(value).toLocaleString("en-CA")}`;
    }

    return value;
  };

  return (
    <>
      <Header />

      <LoadScriptNext
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={["places"]}
      >
        {/* ---------------- FILTERS ---------------- */}
        <div className="filter-btn-wrap mpcpde">
          <div className="main-search-bar mapsercgh">
            {/* Search Input */}
            <div>
              <LoadScriptNext
                googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                libraries={["places"]}
              >
                <Autocomplete
                  onLoad={handleAutocompleteLoad}
                  onPlaceChanged={handlePlaceChanged}
                >
                  <input
                    ref={searchInputRef}
                    type="text"
                    className="search-input"
                    placeholder="Enter Any Location"
                    value={search}
                    onChange={(e) => {
                      const value = e.target.value;
                      selectedPredictionRef.current = null; // ✅ reset when typing
                      setSearch(value);

                      // IF SEARCH CLEARED → RESET LOCATION FILTER
                      if (!value.trim()) {
                        setSearchCircleCenter(null); // remove circle
                        setShowNearby(false);

                        localStorage.removeItem("nearby_lat");
                        localStorage.removeItem("nearby_lng");

                        // reset map view
                        if (mapRef.current) {
                          mapRef.current.panTo(CANADA_CENTER);
                          mapRef.current.setZoom(4);
                        }
                      }
                      //if user starts typing again → nearby OFF
                      else if (showNearby) {
                        localStorage.removeItem("nearby_lat");
                        localStorage.removeItem("nearby_lng");
                        setShowNearby(false);
                      }
                    }}
                    onKeyDown={handleEnterApply}
                  />
                </Autocomplete>
              </LoadScriptNext>
            </div>

            {/* Property Type Filter */}
            <select
              className="select-input difko"
              value={propertyType}
              onChange={(e) => setPropertyType(e.target.value)}
              onKeyDown={handleEnterApply}
            >
              <option value="">Property Type</option>
              {propertyTypeOptions.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>

            {/* Min Price Filter */}
            <select
              className="difko"
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
              onKeyDown={handleEnterApply}
            >
              <option value="">No Min</option>
              {priceList.map((price, index) => (
                <option key={index} value={price}>
                  ${price}
                </option>
              ))}
            </select>

            {/* Max Price Filter */}
            <select
              className="difko"
              value={maxPrice}
              onChange={(e) => setMaxPrice(e.target.value)}
              onKeyDown={handleEnterApply}
            >
              <option value="">No Max</option>
              {priceList.map((price, index) => (
                <option key={index} value={price}>
                  ${price}
                </option>
              ))}
            </select>

            <button
              className="filter-btn morefilter"
              onClick={() => setShowFilter(true)}
            >
              More Filter
            </button>

            {/* Apply Button */}
            <button
              className={`applyfilter ${isMobile ? "smallbtn" : ""}`}
              onClick={handleApply}
              disabled={!search && !propertyType && !minPrice && !maxPrice}
              style={{
                opacity:
                  !search && !propertyType && !minPrice && !maxPrice ? 0.6 : 1,
                cursor:
                  !search && !propertyType && !minPrice && !maxPrice
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Apply
            </button>
          </div>

          {/* <div className="newflx">
                   <button
                     className="filter-btn kioklki"
                     onClick={() => setShowFilter(true)}
                   >
                     Filter
                   </button>
                 </div> */}
        </div>
        <div className="resideciolbtn resideciolbtnsx">
          <button
            onClick={() => {
              setIsResidential(true);
              applyOnceRef.current = true;
              if (mapRef.current) {
                mapRef.current.panTo(mapRef.current.getCenter());
              }
            }}
            className={isResidential ? "activeBtn" : ""}
          >
            <img src={Residin} alt="" /> Residential
          </button>

          <button
            onClick={() => {
              setIsResidential(false);
              applyOnceRef.current = true;
              if (mapRef.current) {
                mapRef.current.panTo(mapRef.current.getCenter());
              }
            }}
            className={!isResidential ? "activeBtn" : ""}
          >
           <img src={Vectors} alt="" /> Commercial
          </button>
        </div>
        {/*NO DATA UI */}
        {showNoData && (
          <div className="no-data-overlay">
            <div className="no-data-card">
              <FaMapMarkedAlt size={42} color="#1E88E5" />
              <h3>No Properties Found</h3>
              <p>
                Try changing location, property type, or price range to see
                results.
              </p>
              {/* <button
                onClick={() => {
                  setSearch("");
                  setPropertyType("");
                  setMinPrice("");
                  setMaxPrice("");
                  setSearchCircleCenter(null);
                  setShowNearby(false);

                  localStorage.removeItem("nearby_lat");
                  localStorage.removeItem("nearby_lng");

                  if (mapRef.current) {
                    mapRef.current.panTo(CANADA_CENTER);
                    mapRef.current.setZoom(4);
                  }

                  fetchMapProperties();
                }}
              >
                Clear Filters
              </button> */}
              <button onClick={() => window.location.reload()}>
                Clear Filters
              </button>
            </div>
          </div>
        )}

        {/*Filter Modal - Keep this section as is */}
        {showFilter && (
          <div className="filter-modal">
            <div className="filter-content">
              <span
                className="close-btnbyr"
                onClick={() => setShowFilter(false)}
              >
                &times;
              </span>

              {/*Search Input */}
              {/* <div className="filter-search">
                                    <input
                                      type="text"
                                      className="search-input"
                                      placeholder="Enter Any Location"
                                      value={search}
                                      onChange={(e) => setSearch(e.target.value)}
                                    />
                                  </div> */}

              {/* Grid Layout */}
              <div className="filter-grid-advanced">

        {/* Property Type */}
        <div className="filter-item">
          <label>Property Type</label>
          <select
            value={propertyTypex}
            onChange={(e) => setPropertyTypex(e.target.value)}
          >
            {propertyTypeOptions.map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Price */}
        <div className="filter-item">
          <label>Price</label>
          <div className="range-inputs">
            <select
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
            >
              <option value="">No Min</option>
              {priceList.map((price, index) => (
                <option key={index} value={price}>
                  ${price}
                </option>
              ))}
            </select>

            <select
              value={maxPrice}
              onChange={(e) => setMaxPrice(e.target.value)}
            >
              <option value="">No Max</option>
              {priceList.map((price, index) => (
                <option key={index} value={price}>
                  ${price}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ===== RESIDENTIAL ONLY FIELDS ===== */}
        {isResidential && (
          <>
            {/* Farm Type */}
            {propertyTypex === "Agriculture" && (
              <div className="filter-item">
                <label>Farm Type</label>
                <select
                  value={farmType}
                  onChange={(e) => setFarmType(e.target.value)}
                >
                  <option value="">Any</option>
                  {farmList.map((farm, index) => (
                    <option key={index} value={farm}>
                      {farm}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Parking Type */}
            {propertyTypex === "Parking" && (
              <div className="filter-item">
                <label>Parking Type</label>
                <select
                  value={parkingType}
                  onChange={(e) => setParkingType(e.target.value)}
                >
                  <option value="">Any</option>
                  {parkingList.map((p, index) => (
                    <option key={index} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Beds */}
            {propertyTypex !== "Vacant Land" &&
              propertyTypex !== "Multi Family" &&
              propertyTypex !== "Parking" && (
                <div className="filter-item">
                  <label>Beds</label>
                  <select
                    value={beds}
                    onChange={(e) => setBeds(e.target.value)}
                  >
                    {bedsList.map((b, i) => (
                      <option key={i} value={b}>
                        {b}
                      </option>
                    ))}
                  </select>
                </div>
              )}

            {/* Baths */}
            {propertyTypex !== "Vacant Land" &&
              propertyTypex !== "Multi Family" &&
              propertyTypex !== "Parking" && (
                <div className="filter-item">
                  <label>Baths</label>
                  <select
                    value={baths}
                    onChange={(e) => setBaths(e.target.value)}
                  >
                    {bathsList.map((b, i) => (
                      <option key={i} value={b}>
                        {b}
                      </option>
                    ))}
                  </select>
                </div>
              )}

            {/* Square Footage */}
            {propertyTypex !== "Vacant Land" &&
              propertyTypex !== "Parking" && (
                <div className="filter-item">
                  <label>Square Footage</label>
                  <div className="range-inputs">
                    <select
                      value={minSquareFootage}
                      onChange={(e) =>
                        setMinSquareFootage(e.target.value)
                      }
                    >
                      <option value="">No Min</option>
                      {squareFootageList.map((sqft, index) => (
                        <option key={index} value={sqft}>
                          {sqft}
                        </option>
                      ))}
                    </select>

                    <select
                      value={maxSquareFootage}
                      onChange={(e) =>
                        setMaxSquareFootage(e.target.value)
                      }
                    >
                      <option value="">No Max</option>
                      {squareFootageList.map((sqft, index) => (
                        <option key={index} value={sqft}>
                          {sqft}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
          </>
        )}

        {/* ===== COMMON FIELDS (Residential + Commercial) ===== */}

        {/* Building Type */}
        <div className="filter-item">
          <label>Building Type</label>
          <select
            value={buildingType}
            onChange={(e) => setBuildingType(e.target.value)}
          >
            <option value="">Building Type</option>
            {buildingTypes.map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Maintenance Fees */}
        <div className="filter-item">
          <label>Maintenance Fees - Monthly</label>
          <div className="range-inputs">
            <select
              value={maintenanceFeeMin}
              onChange={(e) => setMaintenanceFeeMin(e.target.value)}
            >
              <option value="">No Min</option>
              {maintenanceFeeMonthlyList.map((fee, index) => (
                <option key={index} value={fee}>
                  {fee}
                </option>
              ))}
            </select>

            <select
              value={maintenanceFeeMax}
              onChange={(e) => setMaintenanceFeeMax(e.target.value)}
            >
              <option value="">No Max</option>
              {maintenanceFeeMonthlyList.map((fee, index) => (
                <option key={index} value={fee}>
                  {fee}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Property Tax */}
        <div className="filter-item">
          <label>Property Tax - Yearly</label>
          <div className="range-inputs">
            <select
              value={propertyTaxMin}
              onChange={(e) => setPropertyTaxMin(e.target.value)}
            >
              <option value="">No Min</option>
              {propertyTaxYearlyList.map((tax, index) => (
                <option key={index} value={tax}>
                  {tax}
                </option>
              ))}
            </select>

            <select
              value={propertyTaxMax}
              onChange={(e) => setPropertyTaxMax(e.target.value)}
            >
              <option value="">No Max</option>
              {propertyTaxYearlyList.map((tax, index) => (
                <option key={index} value={tax}>
                  {tax}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Year Built */}
        <div className="filter-item">
          <label>Years Built</label>
          <div className="range-inputs">
            <select
              value={yearBuiltFrom}
              onChange={(e) => setYearBuiltFrom(e.target.value)}
            >
              <option value="">No Min</option>
              {yearBuiltList.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>

            <select
              value={yearBuiltTo}
              onChange={(e) => setYearBuiltTo(e.target.value)}
            >
              <option value="">No Max</option>
              {yearBuiltList.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

      </div>

              {/* Buttons */}
              <div className="filter-actions-advanced">
                <button
                  className="reset-btn"
                  onClick={() => {
                    setSearch("");
                    setPropertyType("");
                    setMinPrice("");
                    setMaxPrice("");
                    setBeds("");
                    setBaths("");
                    setPropertyTypex("");
                    setFarmType("");
                    setParkingType("");
                    setBuildingStyle("");
                    setNumberOfUnits("");
                    setExteriorBuildingSize("");
                    setOwnershipTitle("");
                    setZoningType("");
                    setLandSize("");
                    setMinSquareFootage("");
                    setMaxSquareFootage("");
                    setBuildingType("");
                    setStories("");
                    fetchMapProperties();
                  }}
                >
                  <img src={resetimg} alt="" /> Reset Filter
                </button>
                <button
                  className="apply-btn"
                  onClick={() => {
                    const applied = {
                      search,
                      propertyType: propertyTypex,
                      minPrice,
                      maxPrice,
                      farmType,
                      parkingType,
                      beds,
                      baths,
                      minSquareFootage,
                      maxSquareFootage,
                      buildingType,
                      Stories,
                      ownershipTitle,
                      numberOfUnits,
                      exteriorBuildingSize,
                      landSize,
                      zoningType,
                      listedSince,
                      maintenanceFeeMin,
                      maintenanceFeeMax,
                      propertyTaxMin,
                      propertyTaxMax,
                      yearBuiltFrom,
                      yearBuiltTo,
                    };

                    // 🔥 UI ke liye
                    setAppliedFilters(applied);

                    // 🔥 Map/API ke liye
                    setPropertyType(propertyTypex || "");

                    skipNextIdleRef.current = true;
                    applyOnceRef.current = true;

                    setShowFilter(false);

                    if (mapRef.current) {
                      mapRef.current.panTo(mapRef.current.getCenter());
                    }
                  }}
                >
                  Apply Filter
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="showfilters frfrshowfilters">
          {Object.keys(appliedFilters).length > 0 && (
            <div className="applied-filters">
              <h4>
                Applied <br />
                Filters:
              </h4>

              <ul className="filters-inline">
                {Object.entries(appliedFilters)
                  .filter(([_, value]) => value !== "" && value !== null)
                  .map(([key, value]) => (
                    <li key={key}>
                      <strong>{key}:</strong> {value}
                    </li>
                  ))}
              </ul>

              {/* 🔥 SINGLE CLOSE BUTTON */}
              <span
                className="close-btnbyrs"
                onClick={() => window.location.reload()}
              >
                &times;
              </span>
            </div>
          )}
        </div>

        {/* ---------------- MAP ---------------- */}
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={mapCenter}
          zoom={mapZoom}
          options={mapOptions}
          onLoad={(map) => {
            mapRef.current = map;

            // ✅ MOBILE ONLY FIX
            if (window.innerWidth <= 480) {
              map.setZoom(2.8); // zoom out
              map.panTo(CANADA_CENTER);
            }
          }}
          onIdle={debouncedFetch}
          onZoomChanged={() => {
            if (mapRef.current) {
              setMapZoom(mapRef.current.getZoom());
            }
          }}
        >
          {/* SEARCH CIRCLE */}
          {searchCircleCenter && (
            <Circle
              center={searchCircleCenter}
              radius={4000} // 4 KM
              options={{
                strokeColor: "#1E88E5",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#1E88E5",
                fillOpacity: 0.15,
              }}
            />
          )}

          {/* CLUSTER MARKERS */}
          {mapClusters.map((item, i) =>
            item?.latitude && item?.longitude ? (
              <Marker
                key={i}
                position={{ lat: item.latitude, lng: item.longitude }}
                icon={generateClusterIcon(item.count)}
                onClick={() => {
                  if (loading) return;
                  const cluster = {
                    gridLat: item.gridLat,
                    gridLng: item.gridLng,
                  };
                  setSelectedCluster(cluster);
                  setShowPopup(true);
                  fetchClusterProperties(cluster, 0);
                }}
              />
            ) : null,
          )}

          {mapClusters.map((item, i) =>
            item?.latitude && item?.longitude ? (
              <Marker
                key={i}
                position={{ lat: item.latitude, lng: item.longitude }}
                icon={generateClusterIcon(item.count)}
                onClick={() => {
                  if (loading) return; // 🔒 safety check
                  const cluster = {
                    gridLat: item.gridLat,
                    gridLng: item.gridLng,
                  };
                  setSelectedCluster(cluster);
                  setShowPopup(true);
                  fetchClusterProperties(cluster, 0);
                }}
              />
            ) : null,
          )}

          {loading && <div className="map-loader-bar" />}
        </GoogleMap>

        {loading && <div className="map-click-blocker" />}
      </LoadScriptNext>

      {/* ---------------- CLUSTER POPUP ---------------- */}
      {showPopup && (
        <div className="cluster-popup">
          {/* HEADER */}
          <div className="cluster-popup-header">
            <h3>
              <h3>Showing {getHeaderRangeText()}</h3>
            </h3>

            <button onClick={() => setShowPopup(false)}>✖</button>
          </div>

          {/* BODY */}
          <div className="cluster-popup-body">
            {clusterLoading ? (
              // <p className="loading-text">Loading...</p>
              <div className="popup-loader">
                <div className="spinner"></div>
              </div>
            ) : (
              clusterProperties.map((item) => (
                <div key={item.id} className="cluster-card">
                  <img
                    src={item.imageUrl || placeimg}
                    alt="property"
                    onError={(e) => {
                      e.currentTarget.src = placeimg;
                    }}
                  />

                  <div className="cluster-card-content">
                    {(item.listingId || item.propeId) && (
                      <h3 className="mls">
                        {item.listingId ? (
                          <>
                            <strong>MLS No:</strong> {item.listingId}
                          </>
                        ) : (
                          <>
                            <strong>Property Id:</strong> {item.propeId}
                          </>
                        )}
                      </h3>
                    )}
                    <p className="address">{item.unparsedAddress}</p>
                    <span className="price">
                      {/* {formatPrice(item.listPrice)} */}
                      {item?.listPrice && (
                        <p
                          className="listed-by kiojkio"
                          style={{ marginTop: "6px" }}
                        >
                          Listing Price:{" "}
                          <span>
                            {`$${Number(item.listPrice).toLocaleString()}`}
                          </span>
                        </p>
                      )}

                      {/* <button className="VIEWMAKER">View</button> */}
                      <button
                        className="VIEWMAKER"
                        onClick={() => {
                          const listedBy =
                            item.user?.name || item.originatingSystemName;
                          const email = item.user?.email || "";
                          handleViewDetails(
                            item.id,
                            item.propeId,
                            listedBy,
                            email,
                          );
                        }}
                      >
                        View
                      </button>
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* FOOTER / PAGINATION */}
          <div className="pagination">
            <button
              disabled={isFirstPage}
              onClick={() =>
                fetchClusterProperties(selectedCluster, clusterPage - 1)
              }
            >
              Prev
            </button>

            {getPaginationItems().map((item, index) => {
              if (item === "dots-start" || item === "dots-end") {
                return (
                  <span key={`dots-${index}`} className="pagination-dots">
                    …
                  </span>
                );
              }

              return (
                <button
                  key={`page-${item}-${index}`}
                  className={item === clusterPage ? "active" : ""}
                  onClick={() => fetchClusterProperties(selectedCluster, item)}
                >
                  {item + 1}
                </button>
              );
            })}

            <button
              disabled={isLastPage}
              onClick={() =>
                fetchClusterProperties(selectedCluster, clusterPage + 1)
              }
            >
              Next
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Map;
